import { gql } from 'apollo-boost';

export const CREATE_EMPLOYEE_GQL = gql`
  mutation EmploymentCreate(
    $businessId: ID!
    $role: String!
    $name: String!
    $email: String!
    $permissions: [String!]
    $notes: String
    $phoneNumber: String
  ) {
    employment_create(
      input: {
        businessId: $businessId
        role: $role
        name: $name
        email: $email
        permissions: $permissions
        notes: $notes
        phoneNumber: $phoneNumber
      }
    ) {
      employee {
        id
      }
    }
  }
`;
